"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _immutable = require("immutable");

var _AssociationsStore = _interopRequireDefault(require("crm_data/associations/AssociationsStore"));

var _ProfileObjectTypesType = _interopRequireDefault(require("customer-data-objects-ui-components/propTypes/ProfileObjectTypesType"));

var _getEnabledPlaybookAssociations = _interopRequireDefault(require("crm_data/playbooks/utils/getEnabledPlaybookAssociations"));

var DefaultPlaybookAssociationIdsDependency = {
  propTypes: {
    objectType: _ProfileObjectTypesType.default.isRequired,
    subjectId: _propTypes.default.string.isRequired
  },
  stores: [_AssociationsStore.default],
  deref: function deref(_ref) {
    var objectType = _ref.objectType,
        subjectId = _ref.subjectId;
    var associationObjectTypes = (0, _getEnabledPlaybookAssociations.default)(objectType).toList();
    var associationTypes = associationObjectTypes.map(function (associationObjectType) {
      return {
        objectType: objectType,
        objectId: subjectId,
        associationType: objectType + "_TO_" + associationObjectType
      };
    });

    var results = _AssociationsStore.default.get(associationTypes);

    var associationIds = associationObjectTypes.reduce(function (associationMap, resultObjectType, index) {
      var resultsForObject = results.getIn([index, 'results'], (0, _immutable.List)());
      return associationMap.set(resultObjectType, resultsForObject);
    }, (0, _immutable.Map)());
    return associationIds;
  }
};
var _default = DefaultPlaybookAssociationIdsDependency;
exports.default = _default;
module.exports = exports.default;